const collectionAgeFilterKey = 'jig-ageFilter';

class CollectionAgeFilter extends HTMLElement {
  constructor() {
    super();

    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.markActiveOption = this.markActiveOption.bind(this);
  }

  connectedCallback() {
    this.details = this.querySelector('details');
    this.options = Array.from(this.querySelectorAll('[data-age-range]'));
    this.closeButton = this.querySelector('.collection-age-filter__close');

    this.options.forEach((button) => button.addEventListener('click', this.handleOptionClick));
    if (this.closeButton) this.closeButton.addEventListener('click', this.handleClose);

    this.markActiveOption();
    document.addEventListener('age-filter:change', this.markActiveOption);
  }

  disconnectedCallback() {
    this.options.forEach((button) => button.removeEventListener('click', this.handleOptionClick));
    if (this.closeButton) this.closeButton.removeEventListener('click', this.handleClose);
    document.removeEventListener('age-filter:change', this.markActiveOption);
  }

  getStoredRanges() {
    try {
      const storage = localStorage.getItem(collectionAgeFilterKey);
      return storage ? JSON.parse(storage) : [];
    } catch (e) {
      return [];
    }
  }

  markActiveOption() {
    const selected = this.getStoredRanges();
    const activeRange = selected.length ? selected.join(',') : 'all';

    this.options.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.ageRange === activeRange);
    });
  }

  handleOptionClick(e) {
    const range = e.currentTarget.dataset.ageRange;

    // The site-wide <age-filter> element (see age-filter.js / age-filter-dialog.liquid)
    // owns persistence, featured-collection filtering, and link interception. It may
    // upgrade after this element depending on script order, so wait for it here.
    customElements.whenDefined('age-filter').then(() => {
      const ageFilter = document.querySelector('age-filter');
      if (ageFilter) ageFilter.selectRanges(range.split(','));
    });
  }

  handleClose() {
    if (this.details) this.details.removeAttribute('open');
  }
}

customElements.define('collection-age-filter', CollectionAgeFilter);
